export default {
    'primary': '#FFC907',
    'primary-hover': '#DDBA00',
    'primary-shadow': 'rgb(255, 201, 7, .3)',

    'secondary': '#2967C4',
    'secondary-hover': '#21529D',
    'secondary-shadow': 'rgba(41, 103, 195, 0.3)',

    'primary-t40': 'rgba(245, 207, 0, 0.4)',
    'primary-t20': 'rgba(245, 207, 0, 0.2)',
    'primary-t10': 'rgba(245, 207, 0, 0.1)',

    'surface-ground': '#F2F1ED',
    'surface-ground-t5': '#F9F8F6',
    'surface-ground-t50': 'rgba(242, 241, 237, 0.5)',
    'surface-ground-light': '#F8F8F8',
    'surface-ground-shadow': 'rgb(242, 241, 237, 0.3)',
    'surface-white': 'white',
    'surface-dark-ground': '#242422',
    'surface-dark-accent': 'black',
    'surface-dark-ground-shadow': 'rgb(36, 36, 34, 0.3)',
    'surface-light': '#F7F7F7',

    'surface-white-t3': 'rgba(255, 255, 255, 0.03)',
    'surface-white-t10': 'rgba(255, 255, 255, 0.1)',
    'surface-white-t25': 'rgba(255, 255, 255, 0.25)',
    'surface-white-t50': 'rgba(255, 255, 255, 0.5)',

    'surface-black-t3': 'rgba(36, 36, 34, 0.03)',
    'surface-black-t5': 'rgba(36, 36, 34, 0.05)',
    'surface-black-t10': 'rgba(36, 36, 34, 0.1)',
    'surface-black-t15': 'rgba(36, 36, 34, 0.15)',
    'surface-black-t25': 'rgba(36, 36, 34, 0.25)',
    'surface-black-t50': 'rgba(36, 36, 34, 0.5)',
    'surface-black-shadow': 'rgb(0, 0, 0, 0.3)',
    'surface-black-shadow-light': 'rgb(0, 0, 0, 0.1)',

    'text-white': 'white',
    'text-white-subtle': 'rgba(255, 255, 255, 0.7)',
    'body-accent-text': 'black',
    'body-text': '#242422',
    'body-text-shadow': 'rgba(200, 200, 200, 0.3)',
    'subtle-text': 'rgba(36, 36, 34, 0.7)',
    'subtle-text2': 'rgba(36, 36, 34, 0.5)',
    'btn-text-white': 'white',
    'btn-text-black': '#242422',

    'secondary-danger': '#F45431',

    'secondary-success': '#2A8C69',
    'rating-color': 'rgba(255, 201, 7, 1)',
    
    // Viewport
    // --desktop-cummon': '1800px' // this resulotion is used for adaptations of laptops especially MacBooks
    // --desktop-default': '1440px'
    // --desktop-medium': '1280px'
    // --desktop-small': '1024px'
    // --tablet-default': '768px'
    // --mobile-default': '425px'

    'navigation-height': '46px',
    'header-height-default': '100px',
    'header-height-small': '80px',
    'mobile-bar-height': '64px',

    'primary-transition-time': '0s',
    'primary-transition-type': 'ease',
    'primary-transition': 'var(--primary-transition-time) var(--primary-transition-type)',

    'link-default-transition-time': '50ms',
    'link-default-transition-type': 'ease out',
    'link-default-transition': 'var(--link-default-transition-time) var(--link-default-transition-type)',


    'primary-scale-transition-time': '.1s',
    'primary-scale-transition-type': 'ease',
    'primary-scale-transition': 'var(--primary-scale-transition-time) var(--primary-scale-transition-type)',

    'secondary-transition-time': '.1s',
    'secondary-transition-type': 'ease',
    'secondary-transition': 'var(--secondary-transition-time) var(--secondary-transition-type)',

    'primary-active-state-scale': '.95',
    'secondary-active-state-scale': '.8',
    'increasing-active-state-scale': '1.1',

    'disabled-opacity': '0.5',
    'hover-opacity': '0.7',

    'window-shadow': 'rgb(0, 0, 0, 0.4)',

    'modal-z-index': '60',
}